// Per-library configuration for the Media module. `key` matches the backend
// route segment (media/:key) and the sidebar/router paths (/app/media/:key).
export const MEDIA_LIBRARIES = {
  images: {
    key: 'images',
    label: 'Images',
    singular: 'Image',
    extensions: ['jpg', 'jpeg', 'png', 'webp', 'gif'],
    mimePrefix: 'image/',
    maxSize: 10 * 1024 * 1024,
    maxSizeLabel: '10 MB',
  },
  audio: {
    key: 'audio',
    label: 'Audio',
    singular: 'Audio File',
    extensions: ['mp3', 'wav', 'aac', 'm4a'],
    mimePrefix: 'audio/',
    maxSize: 50 * 1024 * 1024,
    maxSizeLabel: '50 MB',
  },
  videos: {
    key: 'videos',
    label: 'Videos',
    singular: 'Video',
    extensions: ['mp4', 'mov', 'avi', 'mkv', 'webm'],
    mimePrefix: 'video/',
    maxSize: 500 * 1024 * 1024,
    maxSizeLabel: '500 MB',
  },
}

const getFileExtension = filename =>
  (filename?.split('.').pop() || '').toLowerCase().trim()

/**
 * The one place the panel reads a media record's file name.
 *
 * Records store the bare file name (`storedName`) and nothing else — no path,
 * no URL. Anything path-like here would mean an un-migrated row, so it is
 * reduced to its last segment rather than rendered as a broken link.
 */
export const getMediaFileName = record => {
  const value = record?.storedName
  if (!value || typeof value !== 'string') return ''
  return value.trim().split(/[?#]/)[0].replace(/\\/g, '/').split('/').filter(Boolean).pop() || ''
}

export const formatFileSize = bytes => {
  const size = Number(bytes)
  if (!size) return '0 B'
  if (size < 1024) return `${size} B`
  if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`
  if (size < 1024 * 1024 * 1024) return `${(size / (1024 * 1024)).toFixed(1)} MB`
  return `${(size / (1024 * 1024 * 1024)).toFixed(2)} GB`
}

// Returns an error message when the file can't be uploaded to this library, else null
export const validateMediaFile = (library, file) => {
  const extension = getFileExtension(file.name)
  if (!library.extensions.includes(extension)) {
    return `Unsupported file type ".${extension}". Allowed: ${library.extensions.join(', ')}`
  }
  if (!file.type || !file.type.toLowerCase().startsWith(library.mimePrefix)) {
    return `Invalid MIME type "${file.type || 'unknown'}"`
  }
  if (file.size > library.maxSize) {
    return `File is larger than the ${library.maxSizeLabel} limit`
  }
  return null
}
